export default {
    new_migration_account: 'Cuenta',
    new_migration_server: 'Servidor',
    new_migration_account_name: 'Nombre de la cuenta',
    new_migration_no_data_available: 'No hay datos disponibles',
    new_migration_entity_to_migrate: 'Entidad a migrar',
    new_migration_contacts: 'Contactos',
    new_migration_categories: 'Categorias',
    new_migration_behavior: 'Comportamiento',
    new_migration_users: 'Usuarios',
    new_migration_drivers: 'Conductores',
    new_migration_devices: 'Dispositivos',
    new_migration_geofences: 'Geocercas',
    new_migration_maintenance: 'Mantenimiento',
    new_migration_import: 'Importar',
    new_migration_import_from_p4: 'Importar desde P4',
    new_migration_records_found: 'Registros encontrados',
    MigrationExists: "La migración existe",
    MigrationNotExists: "La migración no existe",
    new_migration_success_message: "La migración comenzó a ejecutarse",
    new_migration_error_message: "No se ha podido ejecutar la migración debido a un error",
    new_migration_warning_message: "Es necesario verificar que el nombre de las cuentas P4 y PX seleccionadas coinciden",
    new_migration_account_registered: "Ya existe una cuenta registrada con el nombre",
    new_migration_in_px: "en PX",
    new_migration_verify_accounts: "Es necesario verificar que el nombre de las cuentas P4 y PX seleccionadas coinciden",
    new_migration_pair_with_this_px: "Emparejar con esta cuenta PX",
    new_migration_alerts: "Alertas",
    new_migration_speed_override: "Anulación de velocidad",
    new_migration_entities: "Entidades",
}